import { useState, useEffect } from "react";
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton";
import ModalBox from "../../components/ModalBox/ModalBox";
import countries from "./countries";
import ActivityHeader from "../../components/ActivityHeader/ActivityHeader";
import { startModal, resultModal, finalModal } from "./Modals";
import "./GuessCountryGame.css";
import { trackGameStart } from "../../utils/trackEvents";

export default function GuessCountryGame() {
  const [quizCountries, setQuizCountries] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [guessesLeft, setGuessesLeft] = useState(2);
  const [showFlag, setShowFlag] = useState(false);
  const [userGuess, setUserGuess] = useState("");
  const [showStart, setShowStart] = useState(true);
  const [isResultOpen, setIsResultOpen] = useState(false);
  const [isFinalOpen, setIsFinalOpen] = useState(false);
  const [lastCorrect, setLastCorrect] = useState(false);

  const loadCountries = () => {
    fetch(
      "https://restcountries.com/v3.1/all?fields=name,continents,capital,currencies,flags"
    )
      .then((res) => res.json())
      .then((data) => {
        const filtered = data.filter((c) => countries.includes(c.name.common));
        const shuffled = filtered.sort(() => 0.5 - Math.random());
        setQuizCountries(shuffled.slice(0, 5));
      });
  };

  useEffect(() => {
    loadCountries();
  }, []);

  if (!quizCountries.length) return <div>Loading...</div>;

  const country = quizCountries[currentIndex];

  const handleShowFlag = () => {
    setShowFlag(true);
    setScore((s) => s - 200);
  };

  const handleGuess = () => {
    const correct =
      userGuess.trim().toLowerCase() === country.name.common.toLowerCase();

    if (correct) {
      setLastCorrect(true);
      setScore((s) => s + 500);
      setIsResultOpen(true);
    } else if (guessesLeft > 1) {
      setGuessesLeft((g) => g - 1);
      setUserGuess("");
    } else {
      setLastCorrect(false);
      setGuessesLeft(0);
      setIsResultOpen(true);
    }
  };

  const handleNext = () => {
    setIsResultOpen(false);
    if (currentIndex + 1 < quizCountries.length) {
      setCurrentIndex((i) => i + 1);
      setGuessesLeft(2);
      setShowFlag(false);
      setUserGuess("");
    } else {
      setIsFinalOpen(true);
    }
  };

  return (
    <div className="guess-country-main">
      <ActivityHeader>
        <div className="guess-country-header-level">{`Country: ${
          currentIndex + 1
        }/${quizCountries.length}`}</div>
        <div className="guess-country-header-score">{`Score: ${score}`}</div>
        <span>Guesses Left: {guessesLeft}</span>
      </ActivityHeader>

      <div className="guess-country-content">
        <div className="guess-country-content-question">
          <div className="guess-country-continent">
            Continent: {country.continents[0]}
          </div>
          <div className="guess-country-currency">
            Currency: {Object.keys(country.currencies)[0]}
          </div>
          <div className="guess-country-capital">
            Capital: {country.capital[0]}
          </div>
          <div className="guess-country-flag">
            {showFlag ? (
              <img
                src={country.flags.svg}
                alt={`Flag of ${country.name.common}`}
                className="guess-country-flag-img"
              />
            ) : (
              <PrimaryButton onClick={handleShowFlag} type="retry">
                Flag
              </PrimaryButton>
            )}
          </div>
          <div className="guess-country-submit">
            <div className="guess-country-guess">
              <input
                type="text"
                value={userGuess}
                onChange={(e) => setUserGuess(e.target.value)}
                placeholder="Enter country name"
                disabled={isResultOpen || guessesLeft === 0}
              />
            </div>

            <PrimaryButton onClick={handleGuess} disabled={guessesLeft === 0}>
              Guess
            </PrimaryButton>
          </div>
        </div>
      </div>

      <ModalBox
        isOpen={showStart}
        {...startModal()}
        onClose={() => {
          setShowStart(false);
          trackGameStart("GuessCountryGame", 1);
        }}
      />

      {!isFinalOpen && (
        <ModalBox
          isOpen={isResultOpen}
          {...resultModal(
            lastCorrect,
            country.name.common,
            currentIndex + 1 === quizCountries.length,
            country.flags.svg
          )}
          onClose={handleNext}
        />
      )}

      {isFinalOpen && (
        <ModalBox
          isOpen={isFinalOpen}
          {...finalModal(score)}
          onClose={() => {
            setIsFinalOpen(false);
            setCurrentIndex(0);
            setScore(0);
            setGuessesLeft(2);
            setShowFlag(false);
            setUserGuess("");
            loadCountries();
          }}
        />
      )}
    </div>
  );
}
